import React, { useEffect, useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const PaymentConfigSection = ({ data, onChange, onSave }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [localData, setLocalData] = useState(data);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    setLocalData(data);
    setIsEditing(false);
    setIsSaving(false);
  }, [data]);

  const bankOptions = [
    { value: 'kb', label: 'KB국민은행' },
    { value: 'shinhan', label: '신한은행' },
    { value: 'woori', label: '우리은행' },
    { value: 'hana', label: '하나은행' },
    { value: 'nh', label: 'NH농협은행' },
    { value: 'ibk', label: 'IBK기업은행' },
    { value: 'kakao', label: '카카오뱅크' },
    { value: 'toss', label: '토스뱅크' }
  ];

  const deadlineOptions = [
    { value: '1', label: '세션 1일 전' },
    { value: '2', label: '세션 2일 전' },
    { value: '3', label: '세션 3일 전' },
    { value: '7', label: '세션 7일 전' }
  ];

  const handleChange = (field, value) => {
    setLocalData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSave = async () => {
    setIsSaving(true);
    await onSave(localData);
    setIsSaving(false);
    setIsEditing(false);
  };

  const handleCancel = () => {
    setLocalData(data);
    setIsEditing(false);
  };

  return (
    <div className="bg-card rounded-xl border border-border p-4 md:p-6 lg:p-8">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-success/10 rounded-md flex items-center justify-center">
            <Icon name="CreditCard" size={20} color="var(--color-success)" />
          </div>
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground">
              결제 설정
            </h2>
            <p className="text-sm caption text-muted-foreground">
              결제 계좌 및 처리 방식을 설정합니다
            </p>
          </div>
        </div>
        
        {!isEditing && (
          <Button
            variant="outline"
            size="default"
            iconName="Edit"
            iconPosition="left"
            onClick={() => setIsEditing(true)}
          >
            수정
          </Button>
        )}
      </div>
      <div className="space-y-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6">
          <Select
            label="은행"
            options={bankOptions}
            value={localData?.bankName}
            onChange={(value) => handleChange('bankName', value)}
            disabled={!isEditing}
            required
          />
          
          <Input
            label="계좌번호"
            type="text"
            placeholder="123-456-789012"
            value={localData?.accountNumber}
            onChange={(e) => handleChange('accountNumber', e?.target?.value)}
            disabled={!isEditing}
            required
          />
        </div>

        <Input
          label="예금주"
          type="text"
          placeholder="홍길동"
          value={localData?.accountHolder}
          onChange={(e) => handleChange('accountHolder', e?.target?.value)}
          disabled={!isEditing}
          required
        />

        <Select
          label="결제 마감 기한"
          options={deadlineOptions}
          value={localData?.paymentDeadline}
          onChange={(value) => handleChange('paymentDeadline', value)}
          disabled={!isEditing}
          required
          description="참가자가 결제를 완료해야 하는 기한"
        />

        <div className="bg-warning/10 border border-warning/20 rounded-md p-4">
          <div className="flex items-start gap-3">
            <Icon name="AlertTriangle" size={20} color="var(--color-warning)" />
            <div className="flex-1">
              <h4 className="text-sm font-medium text-foreground mb-1">
                계좌 정보 보안
              </h4>
              <p className="text-sm caption text-muted-foreground">
                계좌 정보는 참가자에게만 공개되며, 안전하게 암호화되어 저장됩니다.
              </p>
            </div>
          </div>
        </div>

        {isEditing && (
          <div className="flex gap-3 pt-4 border-t border-border">
            <Button
              variant="outline"
              onClick={handleCancel}
              disabled={isSaving}
              fullWidth
            >
              취소
            </Button>
            <Button
              variant="default"
              onClick={handleSave}
              loading={isSaving}
              iconName="Save"
              iconPosition="left"
              fullWidth
            >
              저장
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default PaymentConfigSection;